export const navLinks = [
  {
    id: "home",
    title: "Beranda",
  },
  {
    id: "product",
    title: "Produk",
  },
  {
    id: "contact",
    title: "Kontak",
  },
];

export const footerLinks = [
  {
    title: "Links",
    links: [
      {
        name: "Merah Putih Cyber",
        link: "https://www.merahputihcyber.com/",
      },
      {
        name: "Hidrogen",
        link: "https://hidrogen.id/",
      },
      {
        name: "Budidaya Ulat Jerman",
        link: "https://www.ulatjerman.id/",
      },
    ],
  },
  {
    title: "Partner",
    links: [
      {
        name: "Rudy Sumardi",
        link: "https://rudysumardi.com/",
      },
      {
        name: "Teguh Arief",
        link: "https://www.teguharief.com/",
      },
    ],
  },
];